import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/$locale/_public/')({
  beforeLoad: ({ params }) => {
    throw redirect({ href: `/${params.locale}/matches` })
  },
})
